 <h2 mat-dialog-title class="dialog-header d-flex align-items-center justify-content-between">
    <span class="title">{{ 'tariffsInfo.txtTitle' | translate }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#1f1f1f" (click)="clickIconClose($event)">
        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z"/>
    </svg>
 </h2>
 <mat-dialog-content>
      <div class="d-flex justify-content-start align-items-center block-tariffs">
        <div class="tariffs-info d-flex flex-column">
            <div class="heading d-flex flex-column align-items-center">
                <div class="title-tariff d-flex align-items-center justify-content-center">{{ 'tariffsInfo.txtDemo' | translate }}</div>
                <div class="price-teriff d-flex justify-content-center align-items-center">
                    <span class="price">$0</span>
                    <span class="text">/{{ 'tariffsInfo.txtMonth' | translate }}</span>
                </div>
            </div>
            <div class="line"></div>
            <div class="lists d-flex flex-column">
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 1</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 2</span>
                </div>
                <div class="item-list d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 3</span>
                </div>
                <div class="item-list d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <!-- <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg> -->
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 4</span>
                </div>
                <div class="item-list d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <!-- <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg> -->
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 5</span>
                </div>
            </div>
            <button type="button" class="btn-tariff d-flex align-items-center justify-content-center">
                <span>{{ 'tariffsInfo.txtChoose' | translate }}</span>
            </button>
        </div>
        <div class="tariffs-info active d-flex flex-column">
            <div class="additional-information">
                <span innerHTML="{{ 'tariffsInfo.txtMentor' | translate }}"></span>
            </div>
            <div class="heading d-flex flex-column align-items-center">
                <div class="title-tariff d-flex align-items-center justify-content-center">{{ 'tariffsInfo.txtLeader' | translate }}</div>
                <div class="price-teriff d-flex justify-content-center align-items-center">
                    <span class="price">$19</span>
                    <span class="text">/{{ 'tariffsInfo.txtMonth' | translate }}</span>
                </div>
            </div>
            <div class="line"></div>
            <div class="lists d-flex flex-column">
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 1</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 2</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 3</span>
                </div>
                <div class="item-list d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 4</span>
                </div>
                <div class="item-list d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 5</span>
                </div>
            </div>
            <button type="button" class="btn-tariff d-flex align-items-center justify-content-center">
                <span>{{ 'tariffsInfo.txtChoose' | translate }}</span>
            </button>
        </div>
        <div class="tariffs-info d-flex flex-column">
            <div class="heading d-flex flex-column align-items-center">
                <div class="title-tariff d-flex align-items-center justify-content-center">{{ 'tariffsInfo.txtAdditional' | translate }}</div>
                <div class="price-teriff d-flex justify-content-center align-items-center">
                    <span class="price">$29</span>
                    <span class="text">/{{ 'tariffsInfo.txtMonth' | translate }}</span>
                </div>
            </div>
            <div class="line"></div>
            <div class="lists d-flex flex-column">
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 1</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 2</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 3</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 4</span>
                </div>
                <div class="item-list d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 5</span>
                </div>
            </div>
            <button type="button" class="btn-tariff d-flex align-items-center justify-content-center">
                <span>{{ 'tariffsInfo.txtChoose' | translate }}</span>
            </button>
        </div>
        <div class="tariffs-info d-flex flex-column">
            <div class="heading d-flex flex-column align-items-center">
                <div class="title-tariff d-flex align-items-center justify-content-center">{{ 'tariffsInfo.txtFriend' | translate }}</div>
                <div class="price-teriff d-flex justify-content-center align-items-center">
                    <span class="price">$49</span>
                    <span class="text">/{{ 'tariffsInfo.txtMonth' | translate }}</span>
                </div>
            </div>
            <div class="line"></div>
            <div class="lists d-flex flex-column">
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 1</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 2</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 3</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 4</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 5</span>
                </div>
            </div>
            <button type="button" class="btn-tariff d-flex align-items-center justify-content-center">
                <span>{{ 'tariffsInfo.txtChoose' | translate }}</span>
            </button>
        </div>
        <div class="tariffs-info d-flex flex-column">
            <div class="heading d-flex flex-column align-items-center">
                <div class="title-tariff d-flex align-items-center justify-content-center">{{ 'tariffsInfo.txtFriend' | translate }}</div>
                <div class="price-teriff d-flex justify-content-center align-items-center">
                    <span class="price">$49</span>
                    <span class="text">/{{ 'tariffsInfo.txtMonth' | translate }}</span>
                </div>
            </div>
            <div class="line"></div>
            <div class="lists d-flex flex-column">
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 1</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 2</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 3</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 4</span>
                </div>
                <div class="item-list available d-flex align-items-center justify-content-start">
                    <span class="icon-check">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8125 3.93774L5.6875 10.0625L2.625 7.00024" stroke="#71C55D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <span>{{ 'tariffsInfo.txtText' | translate }} 5</span>
                </div>
            </div>
            <button type="button" class="btn-tariff d-flex align-items-center justify-content-center">
                <span>{{ 'tariffsInfo.txtChoose' | translate }}</span>
            </button>
        </div>
        <div style="opacity: 0;margin-left: -1px;">.</div>
      </div>
 </mat-dialog-content>
 <div class="block-descriptions">
        <span>{{ 'tariffsInfo.txtInfo' | translate }}</span>
      </div>
 <mat-dialog-actions align="center">
     <div class="btns-groups"> 
         <button class="btn-accept" (click)="onNoClick()">
             <span>{{ 'buttons.txtClose' | translate }}</span>
         </button>
     </div>       
   </mat-dialog-actions>
